<template>
  <v-layout row>
    <v-flex xs12 sm6 offset-sm3>
      <v-card>
        <v-btn @click="logout">Log Out</v-btn>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
const fb = require('../firebase')

export default {
  name: 'Profile',
  methods: {
    logout: function () {
      let that = this
      fb.auth.signOut()
        .then(function () {
          that.$router.push({path: '/signin'})
        })
        .catch(function (error) {
          console.log('error', error)
        })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Profile.vue